module.exports = __webpack_public_path__ + "static/media/buildingConstruction12.8c175014.jpg";